module.exports = __webpack_public_path__ + "img/kh.e130823a.jpg";